import React, { useState, useEffect } from "react"
import {
  Card,
  CardBody,
  Col,
  Row,
  Form,
  FormGroup,
  Label,
  Button,
  Input,
} from "reactstrap"
import Select from "react-select"
import { connect } from "react-redux"
import { setBreadcrumbItems } from "../../store/actions"
import { showToaster } from "components/Common/common"
import axiosInstance from "components/Common/ApiManagement/axiosInstance"
import { ApiNames, VIEW_TYPE_OPTIONS } from "components/Common/ApiManagement/apiServices"
import { useNavigate } from "react-router-dom"
import { PAGEPATHS } from "components/Common/Constant"

const CustomReportLayout = props => {
  const navigate = useNavigate()

  const [reportName, setReportName] = useState("")
  const [areaName, setAreaName] = useState([])
  const [scanName, setScanName] = useState([])
  const [scanGroup, setScanGroup] = useState([])
  const [scanTitle, setScanTitle] = useState([])
  const [category, setCategory] = useState([])
  const [scanSubcat, setScanSubcat] = useState([])

  const [selectedViewTypes, setSelectedViewTypes] = useState([])
  const [viewUploadingLoad, setViewUploadLoad] = useState(false)
  const [assignTo, setAssignTo] = useState("everyone")
  const [organizationOptions, setOrganizationOptions] = useState([])
  const [selectedOrganizations, setSelectedOrganizations] = useState([])
const [hasUserEdited, setHasUserEdited] = useState(false);

  const [optionsData, setOptionsData] = useState({
    area: [],
    scanGroup: [],
    scanTitle: [],
    category: [],
    scanSubcat: [],
    scanName: [],
  })

  useEffect(() => {
    props.setBreadcrumbItems("Reference Table Create", [])
    fetchFilterOptions()
    fetchLastSavedConfig()
    fetchOrganizations()
  }, [])

  // useEffect(() => {
  //   if (reportName.trim()) {
  //     fetchViewTypes(reportName)
  //   }
  // }, [reportName])

  const fetchOrganizations = () => {
    axiosInstance
      .get(ApiNames.LIST_ORGANIZATION)
      .then(res => {
        const options = res.data.data.map(org => ({
          label: org.branch,
          value: org._id,
        }))
        setOrganizationOptions(options)
      })
      .catch(err => console.error("Error fetching organizations:", err))
  }

  const fetchLastSavedConfig = async () => {
  try {
    const res = await axiosInstance.get(ApiNames.LAST_SAVED_VIEW_CONFIG);
    const data = res?.data?.data;
    if (!data) return;

    setReportName(data.reportName || "");
    if (!hasUserEdited) {
  setAssignTo(data.assignTo || "everyone");

  if (data.assignTo === "organization" && data.assignedOrganizations) {
    setSelectedOrganizations(
      data.assignedOrganizations.map(org => ({
        label: org.name,
        value: org.id,
      }))
    );
  } else {
    setSelectedOrganizations([]);
  }
}


    // ✅ Add this to load saved layout once
    fetchViewTypes(data.reportName || "");

  } catch (err) {
    console.error("Error fetching last saved config", err);
  }
};


  const fetchViewTypes = async name => {
  try {
    if (!name.trim()) return;

    const res = await axiosInstance.post(ApiNames.VIEW_METHOD_GET, {
      reportName: name.trim(),
    });

    const data = res?.data?.data;
    if (!data) return;

    setSelectedViewTypes(
      (data.viewTypes || [])
        .map(v => VIEW_TYPE_OPTIONS.find(option => option.value === v))
        .filter(Boolean)
    );
    setAreaName((data.areaName || []).map(v => ({ label: v, value: v })));
    setScanGroup((data.scanGroup || []).map(v => ({ label: v, value: v })));
    setScanTitle((data.scanTitle || []).map(v => ({ label: v, value: v })));
    setCategory((data.category || []).map(v => ({ label: v, value: v })));
    setScanSubcat((data.scanSubcat || []).map(v => ({ label: v, value: v })));
    setScanName((data.scanName || []).map(v => ({ label: v, value: v })));

    // ✅ Fix starts here
//     if (!hasUserEdited) {
//   setAssignTo(data.assignTo || "everyone");

//   if (data.assignTo === "organization" && data.assignedOrganizations) {
//     setSelectedOrganizations(
//       data.assignedOrganizations.map(org => ({
//         label: org.name,
//         value: org.id,
//       }))
//     );
//   } else {
//     setSelectedOrganizations([]);
//   }
// }
//     // ✅ Fix ends here

  } catch (err) {
    console.error("Error fetching view config", err);
  }
};

  const fetchFilterOptions = async () => {
    try {
      const res = await axiosInstance.post(ApiNames.CUSTOM_REPORT_LIST)
      if (res.data?.data) {
        const { areas, scanGroup, scanTitle, category, scanSubcat, scanName } =
          res.data.data
          console.log("Custom report filter response:", res.data.data)

        setOptionsData({
          area: areas.map(val => ({ label: val, value: val })),
          scanGroup: scanGroup.map(val => ({ label: val, value: val })),
          scanTitle: scanTitle.map(val => ({ label: val, value: val })),
          category: category.map(val => ({ label: val, value: val })),
          scanSubcat: scanSubcat.map(val => ({ label: val, value: val })),
          scanName: scanName.map(val => ({ label: val, value: val })),
        })
      }
    } catch (err) {
      console.error("Error fetching compliance filters", err)
    }
  }

  const handleUpload = async () => {
    if (!reportName.trim() || selectedViewTypes.length === 0) {
      return showToaster(0, "Report name and at least one View Type are required")
    }
    if (assignTo === "organization" && selectedOrganizations.length === 0) {
        return showToaster(0, "Please select at least one organization");
      }

    if (
      areaName.length === 0 &&
      scanName.length === 0 &&
      scanGroup.length === 0 &&
      category.length === 0 &&
      scanSubcat.length === 0
    ) {
      return showToaster(
        0,
        "Please select at least one option from Compliance Areas, Scan Name, Scan Group, Category, or Sub-Category"
      )
    }

    setViewUploadLoad(true)
    try {
      const res = await axiosInstance.post(ApiNames.VIEW_METHOD_UPLOAD, {
        reportName: reportName.trim(),
        areaName: areaName.map(a => a.value),
        scanGroup: scanGroup.map(a => a.value),
        scanTitle: scanTitle.map(a => a.value),
        category: category.map(a => a.value),
        scanSubcat: scanSubcat.map(a => a.value),
        scanName: scanName.map(a => a.value),
        viewTypes: selectedViewTypes.map(v => v.value),
        assignTo,
        assignedOrganizations:
          assignTo === "organization"
            ? selectedOrganizations.map(org => ({
                id: org.value,
                name: org.label,
              }))
            : [],
      })

      if (res.data.status) {
        showToaster(1, "View type(s) saved successfully")
      } else {
        showToaster(0, "Upload failed")
      }
    } catch (err) {
      console.error("Upload error:", err)
      showToaster(0, "Upload failed")
    } finally {
      setViewUploadLoad(false)
    }
  }

  return (
    <React.Fragment>
      <Row className="justify-content-center">
        <Col lg={8}>
          <Card>
            <CardBody>
              <div className="d-flex justify-content-end mb-3">
                <Button color="secondary" onClick={() =>  navigate('/Savedreportlist')}
>
                  Back to Saved Reports
                </Button>
              </div>

              <h4>Add Custom Report</h4>
              <Form>
                <FormGroup>
                  <Label>Report Name</Label>
                  <Input
                    type="text"
                    value={reportName}
                    onChange={e => setReportName(e.target.value)}
                    placeholder="Enter report name"
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Compliance Areas</Label>
                  <Select
                    isMulti
                    value={areaName}
                    onChange={setAreaName}
                    options={optionsData.area}
                    placeholder="Select Area"
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Scan Name</Label>
                  <Select
                    isMulti
                    value={scanName}
                    onChange={setScanName}
                    options={optionsData.scanName}
                    placeholder="Select Scan Name"
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Scan Group</Label>
                  <Select
                    isMulti
                    value={scanGroup}
                    onChange={setScanGroup}
                    options={optionsData.scanGroup}
                    placeholder="Select Scan Group"
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Category</Label>
                  <Select
                    isMulti
                    value={category}
                    onChange={setCategory}
                    options={optionsData.category}
                    placeholder="Select Category"
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Scan Sub-Category</Label>
                  <Select
                    isMulti
                    value={scanSubcat}
                    onChange={setScanSubcat}
                    options={optionsData.scanSubcat}
                    placeholder="Select Sub-Category"
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Select View Types</Label>
                  <Select
                    isMulti
                    value={selectedViewTypes}
                    onChange={setSelectedViewTypes}
                    options={VIEW_TYPE_OPTIONS}
                    placeholder="Select View Types"
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Assign To</Label>
                  <div className="d-flex gap-4">
                    <Label check>
                      <Input
                        type="radio"
                        name="assignTo"
                        value="everyone"
                        checked={assignTo === "everyone"}
                        onChange={e => {
      setAssignTo(e.target.value);
      setHasUserEdited(true); // <-- ADD THIS
    }}
                      />{" "}
                      Everyone
                    </Label>
                    <Label check>
                      <Input
  type="radio"
  name="assignTo"
  value="organization"
  checked={assignTo === "organization"}
  onChange={e => {
    setAssignTo(e.target.value);
    setHasUserEdited(true);
  }}
/>
{" "}
                      Specific Organization
                    </Label>
                  </div>
                </FormGroup>

                {assignTo === "organization" && (
                  <FormGroup>
                    <Label>Select Organization(s)</Label>
                    <Select
                      isMulti
                      value={selectedOrganizations}
                      onChange={setSelectedOrganizations}
                      options={organizationOptions}
                      placeholder="Select organization(s)"
                    />
                  </FormGroup>
                )}

                <Button color="primary" onClick={handleUpload} disabled={viewUploadingLoad}>
                  {viewUploadingLoad ? "Saving..." : "Save Layout"}
                </Button>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(CustomReportLayout)
